import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Input,
  OnDestroy,
} from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AsyncPipe } from '@angular/common';
import {
  GLOBAL_LOADER_NAME,
  LOADER_BACKDROP_COLOR,
  LOADER_INDICATOR_COLOR,
} from '../../constants/loader.constants';
import { GlobalLoaderService } from '../../services/global-loader.service';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'ls-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxSpinnerModule, AsyncPipe],
  providers: [GlobalLoaderService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GlobalLoaderComponent implements OnDestroy {
  private readonly router = inject(Router);
  private readonly globalLoaderService = inject(GlobalLoaderService);

  @Input() public fullScreen = true;

  public readonly navigationInProgress$ = new BehaviorSubject<boolean>(false);

  public readonly indicatorColor = LOADER_INDICATOR_COLOR;
  public readonly backdropColor = LOADER_BACKDROP_COLOR;
  public readonly loaderName = GLOBAL_LOADER_NAME;

  public readonly text$ = this.globalLoaderService.text$;

  private readonly destroyed$ = new Subject<void>();

  constructor() {
    this.initializeRouterEventsSubscription();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next();
  }

  private initializeRouterEventsSubscription(): void {
    this.router.events.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (event) => {
        if (event instanceof NavigationStart) {
          this.navigationInProgress$.next(true);
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.navigationInProgress$.next(false);
        }
      },
      error: () => this.navigationInProgress$.next(false),
    });
  }
}
